import { translate } from '@components/i18n';
import { Table } from '@components/table';
import { ItemResponse } from '@models/item';
import { fetchItems, itemSelector } from '@redux/slices/item';
import { Col } from 'antd';
import { SorterResult, FilterValue } from 'antd/lib/table/interface';
import React, { memo, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalContext } from 'src/contexts/modal-context';
import { columns } from '../constants';
import { EditModal } from './edit-modal';

export const Body: React.FC = memo(() => {
    const dispatch = useDispatch();
    const itemData = useSelector(itemSelector);
    const modalContext = useContext(ModalContext);

    const edit = (
        data: ItemResponse,
        _: number,
        event: React.MouseEvent<HTMLElement, MouseEvent>,
    ): void => {
        if (
            !`${event.target}`.includes('SVG') &&
            !`${event.target}`.includes('Button') &&
            !`${event.target}`.includes('Span')
        )
            modalContext.setIsOpen(
                true,
                <EditModal data={data} key={`editing-item-${data.numero}`} />,
                {
                    title: `${translate('general.editItem')} - ${data.numero}`,
                    width: '40%',
                },
            );
    };

    const loadData = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        pagination: any,
        _: Record<string, FilterValue>,
        sorter: SorterResult<unknown>,
    ): void => {
        dispatch(
            fetchItems({
                ...pagination,
                field: sorter.field,
                order: sorter.order,
                query: itemData.search.query,
                status: itemData.search.status,
            }),
        );
    };

    return (
        <Col>
            <Table
                columns={columns}
                rowKey={(record: ItemResponse) => `${record.id}`}
                dataSource={itemData.list}
                pagination={itemData.request}
                pointer
                onRowClick={edit}
                scroll={{ y: 'calc(100vh - 380px)' }}
                onChange={loadData}
                isLoading={itemData.isFetching}
            />
        </Col>
    );
});
